import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  lang;
  lang_beh = new BehaviorSubject('');
  overlay_beh = new BehaviorSubject(0);
  constructor(private translateService: TranslateService) {
    // localStorage.setItem('lang', 'en')
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'en')
    }
  }

  initLanguageServices() {
    this.lang = localStorage.getItem('lang')

    if (this.lang == 'ar' || this.lang == 'en') {
      // console.log('initial if lang: ', this.lang)
      this.translateService.setDefaultLang(this.lang);
      this.translateService.use(this.lang);
      this.setDir(this.lang);
      this.lang_beh.next(this.lang)
    }
  }

  setDir(lang) {
    let dir;
    if (lang == 'ar') {
      dir = 'rtl';
    } else {
      dir = 'ltr';
    }
    document.body.setAttribute('dir', dir);
    if (document.getElementsByTagName('nav').length) {
      // console.log('document.getElementsByTagName',document.getElementsByTagName('nav'))
      // document.getElementsByTagName('nav')[0].className += dir;
      document.querySelector('nav').setAttribute('dir', dir)
    }
  }

  changeLanguage(lang) {
    this.translateService.use(lang);
    this.translateService.setDefaultLang(lang);
    this.setDir(lang);
    localStorage.setItem('lang', lang)
    // this.lang_beh.next(lang)
    this.initLanguageServices()
  }
}
